export default __webpack_public_path__ + "media/zurb/img/icons/zurb-logo-black-d2a5dbfca94b03a6045a9a756b8068b5.svg";